import * as z from "zod";

import {
  REQUIRED_MESSAGE,
  dateSchema,
  referenceObject,
  requiredNumber,
  requiredPositiveNumber,
  requiredString,
} from "components/form/utils";

export const billableSchema = (type, status) => {
  const defaults = {
    status: z
      .enum([
        "contracted",
        "pending_invoice",
        "billed",
        "collected",
        "archived",
        "cancelled",
      ])
      .default("contracted"),
    name: requiredString(),
    job: requiredString(),
    type: requiredString(),
    attributed_to: referenceObject(),
    amount: z.optional(z.union([z.number(), z.literal(null)])),
    billing_date: dateSchema,
    start_date: dateSchema,
    end_date: dateSchema,
    due_days: z.union([z.number(), z.null()]).optional(),
    due_date: z.union([dateSchema, z.null()]).optional(),
    forecast_date: z.union([dateSchema, z.null()]).optional(),
    note: z.string().optional().nullable(),
  };

  if (status === "billed" || status === "collected") {
    defaults.invoice_number = requiredString();
    defaults.invoice_date = dateSchema;
    defaults.forecast_date = dateSchema;
  } else {
    defaults.invoice_number = z.union([z.string().optional(), z.null()]);
  }

  if (status === "billed" || status === "collected") {
    defaults.adjusted_amount = requiredNumber();
    if (status === "collected") {
      defaults.collected_date = dateSchema;
    }
  } else {
    defaults.adjusted_amount = z
      .union([z.number(), z.literal(null)])
      .optional();
  }

  if (type === "fixed") {
    defaults.amount = requiredPositiveNumber("Amount is required");
  } else if (type === "hourly") {
    defaults.milestones = z.array(z.any()).min(1, "Milestones are required");
    defaults.hourly_billing_config =
      status !== "contracted"
        ? z.object({
          billable_hours: requiredPositiveNumber(
            "Hours should always be in positive",
          ),
        })
        : z.object({
          billable_hours: z.union([
            requiredPositiveNumber(
              "Hours should always be in positive",
            ).optional(),
            z.null(),
          ]),
        });
  } else if (type === "dedicated") {
    defaults.dedicated_billing_config =
      status !== "contracted"
        ? z.object({
          working_days: requiredPositiveNumber("Working days is required"),
          billable_days: requiredPositiveNumber(
            0,
            "Billable days is required",
          ),
        })
        : z.object({
          working_days: z.union([z.number().optional(), z.null()]),
          billable_days: z.union([z.number().optional(), z.null()]),
        });
  } else if (type === "recurring") {
    defaults.milestones = z.array(z.any()).optional();
  }

  return z.object(defaults);
};
